<script lang="ts">
  import { page } from "$app/stores";

  import { getReasonPhrase } from "http-status-codes";

  import errorImage from "$lib/assets/marketing/error-image.svg";
  import A from "$lib/ui/system/A.svelte";
</script>

<main class="px-8">
  <div class="max-w-screen-xl mx-auto py-32">
    <img
      src={errorImage}
      alt="An error occurred"
      class="mx-auto w-full max-w-sm mb-16"
    />
    <h2 class="text-4xl text-c-green-100 text-center">
      {$page.status}
      {getReasonPhrase($page.status)}
    </h2>
    <p class="text-center text-lg my-4">
      {#if $page.status === 404}
        We couldn't find what you were looking for!
      {:else}
        {$page.error?.message ?? "An unknown error occurred."}
      {/if}
    </p>
    <p class="text-center">
      <A href="/">Return home</A>
    </p>
  </div>
</main>
